import { render } from "./SessionExpired.vue?vue&type=template&id=1fa6ebd8&scoped=true"
import script from "./SessionExpired.vue?vue&type=script&lang=js"
export * from "./SessionExpired.vue?vue&type=script&lang=js"

import "./SessionExpired.vue?vue&type=style&index=0&id=1fa6ebd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa6ebd8"]])

export default __exports__